import React, { useEffect, useState } from 'react';

import { ReactComponent as IconArrowUp } from '../../public/images/icons/arrow-up.svg';
import { ReactComponent as IconArrowDown } from '../../public/images/icons/arrow-down.svg';

import './index.scss';

const Input = ({ onChange }) => {
  const [inputValue, setInputValue] = useState('');
  const isInputValueLessZero = inputValue <= 0 || inputValue === '';

  useEffect(() => {
    onChange && onChange(inputValue);
  }, [inputValue]);

  const handleChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleIncrease = () => {
    setInputValue(+inputValue + 1);
  };

  const handleDecrease = () => {
    if (isInputValueLessZero) return;
    setInputValue(+inputValue - 1);
  };

  return <div className='input'>
    <input className='input__field' type='number' id='guests' name='guests' placeholder='0' pattern='[0-9]*'
           value={inputValue} onChange={handleChange} onWheel={event => event.preventDefault()} />
    <button className='input__btn input__btn_increase' type='button' onClick={handleIncrease}>
      <IconArrowUp fill='#45286B' />
    </button>
    <button className='input__btn input__btn_decrease' type='button' onClick={handleDecrease}>
      <IconArrowDown fill={`${isInputValueLessZero ? '#B5A9C4' : '#45286B'}`} />
    </button>
  </div>;
};

export default Input;
